import { doRequest, Methods } from 'Request';

import {
  CeaseRequestDetails,
  CeaseRequestDetailsResponse,
  CreateCeaseRequestPayload,
} from '../types/cease';

export const ceaseRequestsPath = () => `/requests/cease`;
export const ceaseRequestPath = (id: string) => `${ceaseRequestsPath()}/${id}`;

export const toCeaseDetails = (raw: CeaseRequestDetailsResponse): CeaseRequestDetails => {
  return {
    id: raw.id,
    reference: raw.reference,
    status: raw.status,
    category: raw.category || undefined,
    subCategory: raw.sub_category || undefined,
    submittedAt: raw.submitted_at,
    createdAt: raw.created_at || undefined,
    updatedAt: raw.updated_at || undefined,
    snowReference: raw.snow_reference || undefined,
    integrationStatus: raw.integration_status || undefined,
    requestedCeaseDate: raw.requested_cease_date,
    idn: raw.idn,
    ceaseReason: raw.cease_reason,

    customerId: raw.customer_id,
    customerName: raw.customer_name || '',
    submittedBy: raw.submitted_by,
    relationships: raw.relationships,
    included: raw.included,
    primaryContactName: raw.primary_contact_name,
    primaryContactEmail: raw.primary_contact_email,
    primaryContactPhone: raw.primary_contact_phone,
    secondaryContactEmail: raw.secondary_contact_email || undefined,
    details: raw.details || undefined,
    customerReference: raw.customer_reference || undefined,
  };
};

export const createCeaseRequest = async (payload: CreateCeaseRequestPayload): Promise<CeaseRequestDetails> => {
  const response = await doRequest<CeaseRequestDetailsResponse>({
    method: Methods.POST,
    path: ceaseRequestsPath(),
    body: payload,
  });

  return toCeaseDetails(response);
};

export const getCeasesRequest = async (customerId: string): Promise<CeaseRequestDetails[]> => {
  const response = await doRequest<{ data: CeaseRequestDetailsResponse[] }>({
    method: Methods.GET,
    path: ceaseRequestsPath(),
    params: { customer_id: customerId },
  });

  return response.data.map(toCeaseDetails);
};

export const getCeaseRequest = async (customerId: string, id: string): Promise<CeaseRequestDetails> => {
  const response = await doRequest<CeaseRequestDetailsResponse>({
    method: Methods.GET,
    path: ceaseRequestPath(id),
    params: { customer_id: customerId },
  });

  return toCeaseDetails(response);
};
